export default "__VITE_ASSET__DShaupNu__"